// extracted by mini-css-extract-plugin
module.exports = {"container":"noresult_container__1z9RV"};